module.exports = __webpack_public_path__ + "static/media/3-min.jpg.4351624e.webp";